const deepClone = (json) => JSON.parse(JSON.stringify(json));

export default deepClone; 
